import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

interface BtnProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: () => void;
  styleType?: 'primary' | 'default' | 'gradient';
  style?: React.CSSProperties;
  className?: string;
}

export const StyledButton = (props: BtnProps) => {
  const { children, style, className, onClick, styleType = 'default', ...restProps } = props;

  return (
    <button className={cx(styleType, className)} style={style} onClick={onClick} {...restProps}>
      {children}
    </button>
  );
};
